import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import tick from '../resourses/tickbig.png'
import ServicesHeading from '../components/ServicesHeading'
import DividerIcon from '../components/DividerIcon'
import PreFooter from '../components/PreFooter'


const Embarques = props => {
    React.useEffect(() => {
        window.scrollTo(0, 0)
    })
    return (
        <div>
            <ServicesHeading classToAdd="embarques" subtitle={"La calidad es nuestra prioridad"} 
            title={<>Tu carga está en buenas manos</>} 
            subtitleStyle={{backgroundColor: 'rgb(143, 139, 12)', borderRadius: '0 30px 0px 30px', color: 'white', padding: '6px'}}/>
            <DividerIcon />
            <Container className="mt-5">
                <Row>
                    <Col className="">
                        <h5 style={{ fontSize: "25px" }} className="greenblue  mb-2">☑ Monitoreamos cada embarque y resolvemos cualquier imprevisto al instante.

                        </h5>
                        <h5 style={{ fontSize: "25px" }} className="greenblue  mt-3">☑ Control de calidad, atención constante y procesos optimizados<br/> para que todo llegue seguro y confiable. 

                        </h5>
                    </Col>
                </Row>
            </Container>
            <Container className="mt-5 pt-3">
                <Row >
                    <Col md={6} className="text-center">
                        <p style={{ backgroundColor: 'rgb(143, 139, 12)', borderRadius: '0 30px 0px 30px', color: 'white', padding: '10px', width: "100%", fontSize: props.width > 769 ? "24px" : "20px" }} className="bold white mb-n1 px-5">Soluciones que ofrecemos</p>

                    </Col >
                    <Row style={{ backgroundColor: 'whitesmoke', width: "100%" }}>
                        <Col lg={2}></Col>
                        <Col md={12} lg={4} className="d-flex f-column my-5 pl-5 align-items-center">
                            <img src={tick} className="" style={{ objectFit: "contain", width: "25px" }} alt=""/>
                            <p className=" ml-2 mt-1 mb-0 big2">Representación en ventas FOB.</p>
                        </Col>
                        <Col md={12} lg={4} className="d-flex f-column my-5 pl-5 align-items-center">
                            <img src={tick} style={{ objectFit: "contain", width: "25px" }} alt=""/>
                            <p className=" ml-2 mt-1 mb-0 big2"> Servicio de coordinación de cereales, oleaginosas y subproductos.</p>
                        </Col>
                        <Col lg={2}></Col>
                    </Row>
                </Row>
            </Container>
            <Container>
                <Row className="mb-5">
                    <Col className="d-flex justify-content-center">
                       <button onClick={() => window.open("https://www.instagram.com/gualtieriehijos/", '_blank')} 
                        style={{ border: "solid 1px #0E3C39", borderRadius: "0px", backgroundColor: "#0E3C39", fontSize: "1.2rem" }} 
                        className="btn btn-light btn-insta white  mt-5 px-5" > {">"} Conocé más en Instagram</button>
                    </Col>
                </Row>
            </Container>
               <PreFooter />
        </div>
    )
}

export default Embarques
